/**
 * The events an intervento recorded before events existed, from its row: `creato`
 * at `created_at`, `avviato` at `data` once started, `completato` at `updated_at`
 * with the row's esito once completed. Ids are `{id}:{tipo}`, so the backfill, the
 * server and every phone produce the same events, and a union keeps one of each.
 * A row without `operatore_id` has nobody to record them as: no events, and the
 * caller keeps reading the row.
 */
export function synthesizeFromRow(row) {
    if (!row.operatore_id)
        return [];
    const event = (tipo, created_at, esito = null) => ({
        id: `${row.id}:${tipo}`,
        intervento_id: row.id,
        tipo,
        operatore_id: row.operatore_id,
        riparazione_id: null,
        esito,
        note: null,
        created_at,
    });
    const events = [event('creato', row.created_at)];
    if (row.status !== 'bozza')
        events.push(event('avviato', row.data));
    if (row.status === 'completato') {
        events.push(event('completato', row.updated_at, row.esito));
    }
    return events;
}
